import React from 'react';
import DataVisualizationView from '../../components/common/DataVisualizationView';
import Table from '../../components/common/Table/Table';
import { tables } from '../../constants';

/**
 * Battery History Component
 *
 * This component is part of the data visualization stucture and is specifically
 * designed to handle the "Battery History" data. It currently renders a table to
 * display the data but will support graph visualizations in the future.
 *
 * Reponsabilities:
 * - Define how the "Battery History" data is presented.
 * - Render the appropiate components (e.g., Table, Graphs) for this data type.
 *
 * Future enhancements:
 * - Integration of graphs to complement or replace the table for better data insights.
 *
 * @returns {JSX.Element}
 */

const BatteryLife = () => {
  return (
    <DataVisualizationView dataType={tables.battery}>
      {({ currentRecords, columns }) => {
        return <Table columns={columns} data={currentRecords} />;
      }}
    </DataVisualizationView>
  );
};

export default BatteryLife;
